import React from 'react';

import {Button, Anchor} from '@newsela/angelou';

import {signUpRoot} from 'static/three-oh/src/modules/constants/routePaths';

export const JoinLink = React.forwardRef((props, ref) => {
  JoinLink.displayName = 'JoinLink';

  return (
    <Anchor
      href={signUpRoot}
      ref={ref}
      styleAnchorAsButton={{
        flavor: Button.flavor.solid,
        statusColor: Button.statusColor.secondary,
      }}
    >
      Join Now
    </Anchor>
  );
});

export default JoinLink;

